import type { BaseKeyFunction } from "../../../../lib";

export const keyMePayments: BaseKeyFunction = () => ["me", "payments"];
